import styled from 'styled-components';
import React from 'react';
import { Checkbox, CheckboxProps } from '@oneaudi/unified-web-components';
import {
  SYS_BREAKPOINT_2_XL,
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_MD,
  SYS_SPACE_FIXED_200,
  SYS_SPACE_FIXED_300,
  SYS_SPACE_FIXED_500,
  SYS_SPACE_FIXED_600,
  SYS_SPACE_RELATIVE_LG,
} from '@oneaudi/unified-web-common';
import { dynamicStyling, dynamicStylingHelper } from '@oneaudi/vtp-shared';
import { SYS_SPACE_RELATIVE_MD } from '@oneaudi/unified-web-alpha-common';

export const StyledCheckboxWrapper = styled.div`
  display: flex;
`;

export const StyledCheckbox = styled((props) => <Checkbox {...props} />)<CheckboxProps>`
  align-items: ${(props): string => (props.isCarTypeIconCheckbox ? 'center' : 'unset')};

  input {
    height: 20px !important;
  }
`;

export const MoreOptionsButtonsWrapper = styled.div`
  margin-bottom: ${dynamicStylingHelper(SYS_SPACE_FIXED_600, SYS_SPACE_FIXED_500)};
`;

export const FieldsetOneCol = styled((props) => <fieldset {...props} />)`
  display: grid;
  margin: 0;
  padding: 0;
  border-color: transparent;
  margin-block-end: ${dynamicStylingHelper(SYS_SPACE_RELATIVE_LG, SYS_SPACE_FIXED_300)};
  gap: ${dynamicStylingHelper(SYS_SPACE_FIXED_200, SYS_SPACE_RELATIVE_MD)};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    grid-template-columns: repeat(2, 1fr);
    grid-auto-flow: row;
    column-gap: ${SYS_SPACE_FIXED_200};
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    grid-template-columns: repeat(1, 1fr);
  }

  @media (min-width: ${SYS_BREAKPOINT_2_XL}) {
    ${dynamicStyling({
      alpha: `
      grid-template-columns: repeat(2, 1fr);
      column-gap: ${SYS_SPACE_RELATIVE_LG};
    `,
    })};
  }
`;
